import { forwardRef, type Ref, type SVGProps } from 'react';
import { SvgIcon } from '../../components/icon/icon';

interface SVGRProps {
  title?: string;
  titleId?: string;
}
const MessageHeartSingle = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    ref={ref}
    aria-labelledby={titleId}
    {...props}>
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M12 2.764c-5.247 0-9.5 3.78-9.5 8.444a7.96 7.96 0 0 0 2.756 5.934 1.06 1.06 0 0 1 .362.74l.13 2.851a.528.528 0 0 0 .819.416l2.39-1.59a1.07 1.07 0 0 1 .817-.146c.731.159 1.478.24 2.226.24 5.247 0 9.5-3.781 9.5-8.445S17.247 2.764 12 2.764m2.027 5.622A2.2 2.2 0 0 0 12 9.748a2.2 2.2 0 0 0-2.029-1.362 2.4 2.4 0 0 0-2.193 2.421c0 2.651 3.659 4.807 4.222 4.807s4.222-2.156 4.222-4.807a2.4 2.4 0 0 0-2.195-2.421"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);
const ForwardRef = forwardRef(MessageHeartSingle) as SvgIcon;
export { ForwardRef as ReactComponent };
